module.exports = __webpack_public_path__ + "static/schoolsforasia_mapM@2x-e6250b0c86655e73a85e802fc7de4302.png";